"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnuityValidationUtils = void 0;
var Validator_1 = require("../common/Validator");
var ValidationUtils_1 = require("../ValidationUtils");
var AnnuityValidationUtils = /** @class */ (function () {
    function AnnuityValidationUtils() {
    }
    AnnuityValidationUtils.isValidInitialPurchaseAmount = function (productCode, value) {
        if (value < 10000 || value > 3000000) {
            return { isValid: false, message: "Purchase amount must be between $10,000 and $3,000,000" };
        }
        return { isValid: true };
    };
    AnnuityValidationUtils.isValidIncomeStartDate = function (date, productCode) {
        var now = new Date();
        if (!(date instanceof Date)) {
            return { isValid: false, message: 'The income start date must be a valid date' };
        }
        else if (date < now) {
            return { isValid: false, message: 'The income start date must be in the future' };
        }
        else if (date.getDate() > 28) {
            return { isValid: false, message: 'The income start date must be between 1-28' };
        }
        if (productCode === 'CASREC') {
            now.setMonth(now.getMonth() + 13);
            if (date < now) {
                return { isValid: false, message: 'The income start date must be atleast 13 months after today' };
            }
        }
        else if (productCode === 'CASRE') {
            now.setMonth(now.getMonth() + 13);
            if (date > now) {
                return { isValid: false, message: 'The income start date must be within 13 months of today' };
            }
        }
        return { isValid: true };
    };
    AnnuityValidationUtils.isValidProductOptionsCombination = function (ownerType, lives, market) {
        if (ownerType !== 'individual') {
            if (lives !== 'Single-Life') {
                return { isValid: false, message: 'Lives must be Single-Life for non-natural owner' };
            }
            else if (market !== 'Non-Qualified') {
                return { isValid: false, message: 'Market Type must be Non-Qualified for non-natural owner' };
            }
        }
        return { isValid: true };
    };
    AnnuityValidationUtils.isValidDob = function (value) {
        if (!(value instanceof Date)) {
            return { isValid: false, message: 'Date of birth must be a valid date' };
        }
        else if (ValidationUtils_1.ValidationUtils.isYoungerThanAge(value, 22) ||
            ValidationUtils_1.ValidationUtils.isOlderThanOrEqualToAge(value, 88)) {
            return {
                isValid: false,
                message: "Age must be atleast 22 and atmost 88"
            };
        }
        return { isValid: true };
    };
    AnnuityValidationUtils.isValidCASRECAnnuitantDOB = function (dob) {
        var minAge = 21.5;
        var maxAge = 88.5;
        var tooYoung = ValidationUtils_1.ValidationUtils.isYoungerThanAge(dob, minAge);
        var tooOld = ValidationUtils_1.ValidationUtils.isOlderThanOrEqualToAge(dob, maxAge);
        if (tooYoung || tooOld) {
            return {
                isValid: false,
                message: "Must be between ".concat(minAge, " and ").concat(maxAge, " years old")
            };
        }
        return { isValid: true };
    };
    AnnuityValidationUtils.isValidCASREAnnuitantDOB = function (dob, isPeriodCertain) {
        var minAge = isPeriodCertain ? 0 : 17.5;
        var maxAge = isPeriodCertain ? 100.5 : 90.5;
        var tooYoung = ValidationUtils_1.ValidationUtils.isYoungerThanAge(dob, minAge);
        var tooOld = ValidationUtils_1.ValidationUtils.isOlderThanOrEqualToAge(dob, maxAge);
        if (tooYoung || tooOld) {
            return {
                isValid: false,
                message: "Must be between ".concat(minAge, " and ").concat(maxAge, " years old")
            };
        }
        return { isValid: true };
    };
    AnnuityValidationUtils.isValidCASSVOwnerDOB = function (dob, stateCode) {
        var minAge;
        switch (stateCode) {
            case "AL":
            case "DE":
            case "NE":
                minAge = 18.5;
                break;
            case "MS":
                minAge = 20.5;
                break;
            default:
                minAge = 17.5;
        }
        var maxAge = 85.5;
        var tooYoung = ValidationUtils_1.ValidationUtils.isYoungerThanAge(dob, minAge);
        var tooOld = ValidationUtils_1.ValidationUtils.isOlderThanOrEqualToAge(dob, maxAge);
        if (tooYoung || tooOld) {
            return {
                isValid: false,
                message: "Must be between ".concat(minAge, " and ").concat(maxAge, " years old")
            };
        }
        return { isValid: true };
    };
    AnnuityValidationUtils.isValidCASSVAnnuitantDOB = function (dob) {
        var minAge = 0;
        var maxAge = 85.5;
        var tooYoung = ValidationUtils_1.ValidationUtils.isYoungerThanAge(dob, minAge);
        var tooOld = ValidationUtils_1.ValidationUtils.isOlderThanOrEqualToAge(dob, maxAge);
        if (tooYoung || tooOld) {
            return {
                isValid: false,
                message: "Must be between ".concat(minAge, " and ").concat(maxAge, " years old")
            };
        }
        return { isValid: true };
    };
    AnnuityValidationUtils.isIndividualOwnerSelection = function (primary_ownership) {
        return !!primary_ownership && primary_ownership.toUpperCase() === "INDIVIDUAL";
    };
    AnnuityValidationUtils.isLivesSelectionSingleLife = function (lives) {
        return !!lives && lives.toUpperCase() === "SINGLE-LIFE";
    };
    ;
    AnnuityValidationUtils.isLivesSelectionJointLife = function (lives) {
        return !!lives && lives.toUpperCase() === "JOINT-LIFE";
    };
    ;
    AnnuityValidationUtils.isCustodial = function (newPlanOptions) {
        return (newPlanOptions &&
            (newPlanOptions["new_plan_custodial_IRA"] ||
                newPlanOptions["new_plan_custodial_QLAC_IRA"])) ? true : false;
    };
    AnnuityValidationUtils.isNaturalOwnerSelection = function (newPlanOptions, primary_ownership) {
        var isIndividualOwner = AnnuityValidationUtils.isIndividualOwnerSelection(primary_ownership);
        var isCustodial = AnnuityValidationUtils.isCustodial(newPlanOptions);
        return isIndividualOwner && !isCustodial;
    };
    ;
    AnnuityValidationUtils.isQualifiedSelection = function (newPlanOptions) {
        var isNonQualified = newPlanOptions && (newPlanOptions["new_plan_non_qualified"] || newPlanOptions["new_plan_non_qualified_deferred_compensation"]);
        var isQualified = !isNonQualified;
        return isQualified;
    };
    ;
    //for metadata merged in 2021 and earlier
    AnnuityValidationUtils.isAnnuitantSameAsOwner = function (is_annuitant_owner, primary_ownership) {
        if ((primary_ownership === "corporation" || primary_ownership === "trust") &&
            is_annuitant_owner === "Yes") {
            return {
                isAnnuitantSameAsOwner: {
                    message: "Annuitant cannot be a non-natural person.",
                },
            };
        }
        else if (primary_ownership === "individual" &&
            is_annuitant_owner === "No") {
            return {
                isAnnuitantSameAsOwner: {
                    message: "Annuitant must be the same as owner.",
                },
            };
        }
    };
    ;
    //for metadata merged in 2022 and later
    AnnuityValidationUtils.isAnnuitantSameAsOwnerV2 = function (is_annuitant_owner, product_code, primary_ownership, newPlanOptions, annuityOption_RE_Lives) {
        var isNaturalOwner = AnnuityValidationUtils.isNaturalOwnerSelection(newPlanOptions, primary_ownership);
        if (product_code === "CASREC") {
            return AnnuityValidationUtils.isAnnuitantSameAsOwnerV2ValidatorForREC(is_annuitant_owner, isNaturalOwner, newPlanOptions);
        }
        else if (product_code === "CASRE") {
            var isSingleLife = AnnuityValidationUtils.isLivesSelectionSingleLife(annuityOption_RE_Lives);
            var isQualified = AnnuityValidationUtils.isQualifiedSelection(newPlanOptions);
            return AnnuityValidationUtils.isAnnuitantSameAsOwnerV2ValidatorForRE(is_annuitant_owner, isSingleLife, isNaturalOwner, isQualified);
        }
        else if (product_code === "CASSV") {
            return AnnuityValidationUtils.isAnnuitantSameAsOwnerV2ValidatorForSV(is_annuitant_owner, newPlanOptions);
        }
    };
    ;
    AnnuityValidationUtils.isAnnuitantSameAsOwnerV2ValidatorForREC = function (is_annuitant_owner, isNaturalOwner, newPlanOptions) {
        if (!is_annuitant_owner) {
            return undefined;
        }
        if (AnnuityValidationUtils.isCustodial(newPlanOptions) && is_annuitant_owner.toUpperCase() === "YES") {
            return {
                isAnnuitantSameAsOwner: {
                    message: "The Owner and Annuitant cannot be the same at the time the contract is issued.",
                },
            };
        }
        if (!isNaturalOwner && is_annuitant_owner.toUpperCase() === "YES") {
            return {
                isAnnuitantSameAsOwner: {
                    message: "The Owner and Annuitant cannot be the same at the time the contract is issued.",
                },
            };
        }
        if (isNaturalOwner && is_annuitant_owner.toUpperCase() === "NO") {
            return {
                isAnnuitantSameAsOwner: {
                    message: "The Owner and Annuitant must be the same at the time the contract is issued.",
                },
            };
        }
    };
    ;
    AnnuityValidationUtils.isAnnuitantSameAsOwnerV2ValidatorForRE = function (is_annuitant_owner, isSingleLife, isNaturalOwner, isQualified) {
        if (!is_annuitant_owner) {
            return undefined;
        }
        var mustBeNo = (isSingleLife && isQualified) ||
            (isSingleLife && !isQualified && !isNaturalOwner);
        if (mustBeNo && is_annuitant_owner.toUpperCase() === "YES") {
            return {
                isAnnuitantSameAsOwner: {
                    message: "The Owner and Annuitant cannot be the same at the time the contract is issued.",
                },
            };
        }
    };
    ;
    AnnuityValidationUtils.isAnnuitantSameAsOwnerV2ValidatorForSV = function (is_annuitant_owner, newPlanOptions) {
        if (!is_annuitant_owner || !newPlanOptions) {
            return undefined;
        }
        var mustBeYes = newPlanOptions["new_plan_traditional_IRA"] ||
            newPlanOptions["new_plan_ROTH_IRA"] ||
            newPlanOptions["new_plan_SEP_IRA"];
        if (mustBeYes && is_annuitant_owner.toUpperCase() === "NO") {
            return {
                isAnnuitantSameAsOwner: {
                    message: "The Owner and Annuitant must be the same at the time the contract is issued.",
                },
            };
        }
        if (AnnuityValidationUtils.isCustodial(newPlanOptions) && is_annuitant_owner.toUpperCase() === "YES") {
            return {
                isAnnuitantSameAsOwner: {
                    message: "The Owner and Annuitant cannot be the same at the time the contract is issued.",
                },
            };
        }
    };
    ;
    AnnuityValidationUtils.qualifiedMustBeSingleLife = function (lives, newPlanOptions) {
        var isQualified = AnnuityValidationUtils.isQualifiedSelection(newPlanOptions);
        var isSingleLife = AnnuityValidationUtils.isLivesSelectionSingleLife(lives);
        if (isQualified && !isSingleLife) {
            return {
                qualifiedMustBeSingleLife: {
                    message: "Joint Ownership is not permitted with the current plan selection.",
                },
            };
        }
    };
    ;
    AnnuityValidationUtils.canOwnerBeNonNatural = function (isNonNaturalOwner, isSingleLife) {
        if (isNonNaturalOwner && !isSingleLife) {
            return {
                nonNaturalMustBeSingleLifeValidator: {
                    message: "Joint Ownership is not permitted with Non-natural owners.",
                },
            };
        }
    };
    AnnuityValidationUtils.nonNaturalOwnerMustBeSingleLife = function (lives, newPlanOptions, ownership) {
        var isNonNaturalOwner = !AnnuityValidationUtils.isNaturalOwnerSelection(newPlanOptions, ownership);
        var isSingleLife = AnnuityValidationUtils.isLivesSelectionSingleLife(lives);
        return AnnuityValidationUtils.canOwnerBeNonNatural(isNonNaturalOwner, isSingleLife);
    };
    ;
    AnnuityValidationUtils.jointOwner = function (is_there_a_joint_owner, product_code, annuityOption_REC_Lives, annuityOption_RE_Lives, newPlanOptions) {
        if (!is_there_a_joint_owner) {
            return;
        }
        var lives = '';
        if (product_code === "CASRE") {
            lives = annuityOption_RE_Lives;
        }
        else if (product_code === "CASREC") {
            lives = annuityOption_REC_Lives;
        }
        var isSingleLife = AnnuityValidationUtils.isLivesSelectionSingleLife(lives);
        if (isSingleLife && is_there_a_joint_owner.toUpperCase() === "YES") {
            return {
                jointOwner: {
                    message: "Single Life plans cannot have a Joint Owner.",
                },
            };
        }
        var isJointLife = AnnuityValidationUtils.isLivesSelectionJointLife(lives);
        if (isJointLife && is_there_a_joint_owner.toUpperCase() === "NO") {
            return {
                jointOwner: {
                    message: "Joint Life plans must have a Joint Owner.",
                },
            };
        }
        //this is used for CASSV where there are no lives selection
        if (product_code === "CASSV") {
            var isQualified = AnnuityValidationUtils.isQualifiedSelection(newPlanOptions);
            if (isQualified && is_there_a_joint_owner.toUpperCase() === "YES") {
                return {
                    jointOwner: {
                        message: "Joint Ownership is not permitted with the current plan selection.",
                    },
                };
            }
        }
    };
    ;
    AnnuityValidationUtils.newPlan = function (newPlanOptions, primary_ownership, product_code, is_there_a_joint_owner) {
        if (!newPlanOptions || !primary_ownership || !product_code) {
            return;
        }
        var isQualified = AnnuityValidationUtils.isQualifiedSelection(newPlanOptions);
        var isIndividual = AnnuityValidationUtils.isIndividualOwnerSelection(primary_ownership);
        if (isQualified && !isIndividual) {
            return {
                newPlan: {
                    message: "Only individual owners can have Qualified plans."
                }
            };
        }
        // special case for SV - JOINT LIFE - Cannot have qualified options. This case is covered for REC/RE on the lives level
        if (product_code === "CASSV" && isQualified && is_there_a_joint_owner && is_there_a_joint_owner.toUpperCase() === "YES") {
            return {
                newPlan: {
                    message: "Joint Ownership is not permitted with the current plan selection.",
                },
            };
        }
        if (product_code === "CASSV" && !!newPlanOptions['new_plan_non_qualified_deferred_compensation'] && isIndividual) {
            return {
                newPlan: {
                    message: "Non-Qualified Deferred Comp plans do not allow a natural owner."
                }
            };
        }
    };
    //for metadata merged in 2022 and later
    AnnuityValidationUtils.isJointAnnuitantSameAsJointOwnerV2 = function (joint_owner_is_joint_annuitant, product_code, is_there_a_joint_owner) {
        if (!joint_owner_is_joint_annuitant ||
            !product_code ||
            !is_there_a_joint_owner) {
            return undefined;
        }
        if (product_code === "CASREC") {
            if (is_there_a_joint_owner.toUpperCase() === "YES" &&
                joint_owner_is_joint_annuitant.toUpperCase() === "NO") {
                return {
                    jointAnnuitant: {
                        message: "The Joint Owner and Joint Annuitant must be the same at the time the contract is issued.",
                    },
                };
            }
            if (is_there_a_joint_owner.toUpperCase() === "NO" &&
                joint_owner_is_joint_annuitant.toUpperCase() === "YES") {
                return {
                    jointAnnuitant: {
                        message: "Must be no if there is no joint owner.",
                    },
                };
            }
        }
        else if (product_code === "CASRE") {
            if (is_there_a_joint_owner.toUpperCase() === "NO" &&
                joint_owner_is_joint_annuitant.toUpperCase() === "YES") {
                return {
                    jointAnnuitant: {
                        message: "Must be no if there is no joint owner.",
                    },
                };
            }
        }
    };
    ;
    // this validation rule is added as an example. This demonstrates a way to use fetched product specs to run against a business rule. 
    AnnuityValidationUtils.validateEffectiveDateAnnDateGap = function (monthBetween, productType, productCode, state) {
        var specObj = Validator_1.Validator.fetchSpecObjectFromSpecs(productType, productCode, state);
        if (specObj.specs.pendingAnnuitizationPeriodMonths > monthBetween) {
            return { isValid: false, message: "Annuitization date must be at least ".concat(specObj.specs.pendingAnnuitizationPeriodMonths, " months after issue date.") };
        }
        return { isValid: true };
    };
    return AnnuityValidationUtils;
}());
exports.AnnuityValidationUtils = AnnuityValidationUtils;
